<template>
    <div id="payment-settings" class="card settings-content">
        <div class="card-body payment-settings">
            <h4 class="card-title">{{ 'settings.payments' | lang }}</h4>
            <h6 class="card-subtitle">{{ 'settings.setPayments' | lang }}</h6>
            <div class="alert alert-warning" v-if="alert">{{alert}}</div>
            <div class="form-group" :class="{ 'has-danger': errorCountry }">
                <label for="country">{{ 'settings.countryLabel' | lang }}</label>
                <select name="country" id="country" class="form-control" v-model="selectedCountryId"
                        :disabled="!canEdit">
                    <option disabled value="">-</option>
                    <option v-for="country in countries" :value="country.id">
                        {{ country.name }}
                    </option>
                </select>
                <span class="form-control-feedback" v-if="errorCountry">
                <strong>{{ errorCountry }}</strong>
            </span>
            </div>
            <div v-if="selectedCountry" class="form-group payment-options" :class="{ 'has-danger': errorPayment }">
                <label>{{ 'settings.paymentOptionsLabel' | lang }}</label>
                <div v-if="selectedCountry.country_payment_settings.paypal">
                    <input name="payment" type="radio" id="paypal" class="with-gap radio-col-light-blue" value="paypal"
                           v-model="selectedPayment" :disabled="!canEdit">
                    <label for="paypal">{{ 'settings.paymentOptions.paypal' | lang }}</label>
                </div>
<!-- Payoneer                -->
<!--                <div v-if="selectedCountry.country_payment_settings.payoneer">-->
<!--                    <input name="payment" type="radio" id="payoneer" class="with-gap radio-col-light-blue" value="payoneer"-->
<!--                           v-model="selectedPayment" :disabled="!canEdit">-->
<!--                    <label for="paypal">{{ 'settings.paymentOptions.payoneer' | lang }}</label>-->
<!--                </div>-->
                <div v-if="selectedCountry.country_payment_settings.salary">
                    <input name="payment" type="radio" id="salary" class="with-gap radio-col-light-blue" value="salary"
                           v-model="selectedPayment" :disabled="!canEdit">
                    <label for="salary">{{ 'settings.paymentOptions.salary' | lang }}</label>
                </div>
                <div v-if="selectedCountry.country_payment_settings.invoice">
                    <input name="payment" type="radio" id="invoice" class="with-gap radio-col-light-blue"
                           value="invoice"
                           v-model="selectedPayment" :disabled="!canEdit">
                    <label for="invoice">{{ 'settings.paymentOptions.invoice' | lang }}</label>
                </div>
                <span class="form-control-feedback" v-if="errorPayment">
                    <strong>{{ errorPayment }}</strong>
                </span>
              <div>
                <span class="form-control-feedback" v-if="errorPaymentInterval">
                    <strong>{{ errorPaymentInterval }}</strong>
                </span>
              </div>
            </div>

            <div v-if="selectedPayment" class="form-group payment-options" :class="{ 'has-danger': errorCurrency }">
                <label>{{ 'settings.paymentOptions.currency' | lang }}</label>
                <div v-if="selectedPayment==='salary'">
                    <!-- Show SEK-->
                    <input name="currency" type="radio" id="currency-sek" class="with-gap radio-col-light-blue"
                           :value="getCurrencyByCode('SEK').id"
                           v-model="selectedCurrencyId" :disabled="!canEdit">
                    <label for="currency-sek">{{ getCurrencyByCode('SEK').name }}</label>
                </div>
                <div v-else>
                    <!-- Show USD/EUR-->
                    <select name="currency" id="currency" class="form-control" v-model="selectedCurrencyId"
                            :disabled="!canEdit">
                        <option disabled value="">-</option>
                        <option v-for="currency in currencies" :value="currency.id" v-if="currency.code!=='SEK'">
                            {{ currency.name }}
                        </option>
                    </select>
                </div>
                <span class="form-control-feedback" v-if="errorCurrency">
                <strong>{{ errorCurrency }}</strong>
            </span>
            </div>


            <div class="form-group" v-if="selectedCountry" :class="{ 'has-danger': errorEmail }">
                <label for="email">{{ 'settings.email' | lang }}</label>
                <input name="email" id="email" type="email" class="form-control" value="" v-model="email"
                       :disabled="!canEdit">
                <span class="form-control-feedback" v-if="errorEmail">
                <strong>{{ errorEmail }}</strong>
            </span>
            </div>
        </div>
        <div class="card-footer">
            <div v-if="canEdit">
                <button class="btn btn-primary" type="submit" :disabled="disabled">{{ 'settings.save' | lang }}</button>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['countries', 'currencies', 'errors', 'country', 'currency', 'payment_interval', 'type', 'email', 'waitingConfirmation', 'canEdit', 'alert'],
    data() {
      return {
        selectedCountryId: Number(this.country) || '',
        selectedCurrencyId: Number(this.currency) || '',
        selectedPayment: this.type || '',
        selectedInterval: this.payment_interval ?? 'weekly',
      }
    },
    computed: {
      selectedCountry() {
        return this.countries.find((country) => {
          return country.id === this.selectedCountryId;
        });
      },
      selectedCurrency() {
        return this.currencies.find((currency) => {
          return currency.id === this.selectedCurrencyId;
        })
      },
      currencyIdByCode(code) {
        return this.getCurrencyByCode(code).id;
      },
      selectedPaymentForm() {
        if (!this.selectedCountry) {
          return false;
        }
        if (!this.selectedCurrency) {
          return false;
        }
        if (!this.selectedCountry.country_payment_settings[this.selectedPayment]) {
          return false;
        }
        return this.selectedPayment;
      },
      disabled() {
        if (!this.selectedCountry) {
          return true;
        }
        if (!this.selectedCurrency) {
          return true;
        }
        if (!this.selectedPayment) {
          return true;
        }

        if (!this.selectedCountry.country_payment_settings[this.selectedPayment]) {
          return true;
        }

        return !this.email;
      },
      errorCountry() {
        return this.hasError('country');
      },
      errorCurrency() {
        return this.hasError('currency');
      },
      errorPayment() {
        return this.hasError('payment');
      },
      errorEmail() {
        return this.hasError('email');
      },
      errorPaymentInterval() {
        return this.hasError('payment_interval');
      },
    },
    methods: {
      hasError(name) {
        if (!this.errors) {
          return false;
        }
        if (!this.errors[name]) {
          return false;
        }
        if (!this.errors[name][0]) {
          return false;
        }
        return this.errors[name][0];
      },
      getCurrencyByCode(code) {
        return this.currencies.find((item) => {
          return item.code === code;
        });
      }
    }
  }
</script>
